import React from 'react';
import {
  PROFILE_ENTITIES_PROPS,
  tabDefinitionResolver
} from 'UI/components/organisms/inventoryProfiles/commons';
import TabsView from 'UI/components/templates/TabsView';
import { Endpoints } from 'UI/constants/endpoints';
import { JobOrderEntity, TabKeys } from 'UI/constants/entityTypes';
import { getProfileFileDraggableProps } from 'UI/utils';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {Array<Object>} props.tabs
 * @param {Array<Object>} props.profileTabProps
 * @param {Object} props.profileMenuProps
 * @param {Object} props.results
 */
export const createTabViewProps = ({ tabs, profileTabProps, profileMenuProps }) =>
  tabs.map(({ Component, visible = true, props = {}, id, label }) => {
    const currentTab = profileTabProps?.find(item => item.id === id);

    const profileProps = currentTab?.tabProps;

    return {
      id,
      label,
      visible: typeof visible === 'function' ? visible() : visible,
      view: Component && <Component {...props} {...profileProps} {...profileMenuProps} />
    };
  });

/**
 * @param {Object} props
 * @param {boolean} props.enableUrlNavigation
 * @param {string} props.endpoint
 * @param {string} props.entityType
 * @param {boolean} props.isLoading
 * @param {(string|null)} [props.organizationStorageKey]
 * @param {string} props.organizationSubheader
 * @param {Object} props.profileMenuProps
 * @param {Array<Object>} props.profileTabProps
 * @param {Object} props.results
 */
const ProfileTabsWrapper = ({
  enableUrlNavigation,
  endpoint,
  entityType,
  isLoading,
  organizationStorageKey,
  organizationSubheader,
  profileMenuProps,
  profileTabProps,
  results
}) => {
  const classes = useStyles();

  const entityId = entityType?.id;

  const currentEntityProps = PROFILE_ENTITIES_PROPS[entityId];
  const currentTabsProps = currentEntityProps?.defaultTabsProps || {};
  const defaultTabsProps = {
    ...currentTabsProps,
    changeLogProps: {
      tablePreferencesKey: currentEntityProps.defaultTabsProps.changeLogProps.tablePreferencesKey,
      entityId: results?.id,
      profileModule: entityType.title
    }
  };

  const tabs = [
    ...createTabViewProps({
      tabs: tabDefinitionResolver({
        entity: entityId,
        defaultTabsProps,
        enableSearchProjects: entityId !== JobOrderEntity.id,
        endpoint,
        loading: isLoading,
        overviewComponent: currentEntityProps?.overviewComponent,
        overviewProps: currentEntityProps?.overviewProps,
        profile: results,
        tabsDefinition: currentEntityProps?.getTabsDefinition
          ? currentEntityProps?.getTabsDefinition(results?.status?.id)
          : currentEntityProps?.tabsDefinition,
        fileManagerProps: {
          filesEndpoint: `${endpoint}/${Endpoints.Files}`,
          module: currentEntityProps?.fileManagerModule,
          readOnly: false,
          FileDraggableProps: getProfileFileDraggableProps()
        }
      }),
      profileTabProps,
      profileMenuProps,
      results
    })
  ];

  return (
    <TabsView
      className={classes.unsetBackground}
      enableUrlNavigation={enableUrlNavigation}
      initialTab={TabKeys.Overview}
      organizationStorageKey={organizationStorageKey}
      organizationSubheader={organizationSubheader}
      tabPanelProps={{ className: classes.overviewTab }}
      tabs={tabs}
      useIndexes={false}
    />
  );
};

ProfileTabsWrapper.defaultProps = {
  enableUrlNavigation: true
};

export default ProfileTabsWrapper;
